import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { handleModal } from 'src/store/actions/modal';
import Header from './Header';
import Footer from './Footer';
import Modal from 'src/components/reusable/Modal';
import Login from 'src/components/auth/Login';
import Register from 'src/components/auth/Register';
import CheckEmail from 'src/components/auth/CheckEmail';
import AccountVerified from 'src/components/auth/AccountVerified';

type MainLayoutProp = {};

const MainLayout = ({}: MainLayoutProp) => {
  const dispatch = useAppDispatch();

  const { open, openLogin, openRegister, openCheckEmail, openAccountVerified } =
    useAppSelector((state) => state.modal);

  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  if (!isMounted) {
    return null;
  }

  const handleClose = () => {
    dispatch(handleModal(false));
  };

  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Modal
        title={openCheckEmail ? 'Check your email' : null}
        isOpen={open}
        closeModal={handleClose}
      >
        {openLogin && <Login />}
        {openRegister && <Register />}
        {openCheckEmail && <CheckEmail />}
        {openAccountVerified && <AccountVerified />}
      </Modal>
    </>
  );
};

export default MainLayout;
